import { Dayjs } from "dayjs";
import {
  FEEDBACK_STATUS_LIST,
} from "./manageFeedbacksUtils";
import {
  Assignee,
  AssignSubmitRequestData,
  FeedbacksTableDetail,
  FeedbackSummaryData,
  FeedbackSummaryDataObject,
  FeedbackTableRowData,
  ViewSubmitRequestData,
} from "./manageFeedbacksTypes";
import { getMetaData } from "../../services/uiConfigService";
import { ChannelkartNetworkGet, ChannelkartNetworkPut } from "../../services/networkService";
// Function to fetch feedback summary data
export const fetchFeedbackSummaryData = async () => {
  try {
    const feedbackSummaryDataBlob = await getFeedbackSummaryData();
    return getFeedbackSummaryDataInRequiredFormat(feedbackSummaryDataBlob);
  } catch (error) {
    // console.error("Error fetching feedback summary data: ", error);
    // return [];
    throw new Error(`Error fetching feedback summary data: ${error}`); // Re-throw the error for further handling
  }
};

// Function to fetch all feedback data
export const fetchAllFeedbacksData = async (
  dateFilter: Record<string, Dayjs>
) => {
  try {
    const allFeedbacksDataBlob = await getFeedbacksData(dateFilter);
    return getFeedbacksDataInRequiredFormat(allFeedbacksDataBlob);
  } catch (error) {
    // console.error("Error fetching all feedbacks data:", error);
    // return [];
    throw new Error(`Error fetching all feedbacks data: ${error}`); // Re-throw the error for further handling
  }
};

// Function to fetch brands data
export const fetchBrandsData = async () => {
  try {
    const brandsDataBlob = await getBrandsData();
    return getBrandsDataInRequiredFormat(brandsDataBlob);
  } catch (error) {
    // console.error("Error fetching brands data:", error);
    // return [];
    throw new Error(`Error fetching brands data: ${error}`); // Re-throw the error for further handling
  }
};

// Function to fetch flavours data
export const fetchFlavoursData = async () => {
  try {
    const flavoursDataBlob = await getFlavoursData();
    return getFlavoursDataInRequiredFormat(flavoursDataBlob);
  } catch (error) {
    // console.error("Error fetching flavours data:", error);
    // return [];
    throw new Error(`Error fetching flavours data: ${error}`); // Re-throw the error for further handling
  }
};
export const getFeedbackSummaryData =
  async (): Promise<FeedbackSummaryDataObject> => {
    const response = await ChannelkartNetworkGet(
      "/v1/query/FeedbackSummaryReport"
    );
    if (response.status === 200) {
      const data: FeedbackSummaryDataObject = response?.data;
      return data;
    } else {
      // return {} as FeedbackSummaryDataObject;
      throw new Error(
        "Network response was not ok while getting feedback summary data"
      );
    }
  };
export const getFeedbackSummaryDataInRequiredFormat = (
  data: FeedbackSummaryDataObject
): FeedbackSummaryData[] => {
  if (!data.features || !Array.isArray(data.features)) {
    throw new Error("Invalid data structure received");
  }
  return data.features;
};
//TODO : Translate
//TODO : make this configurable
export const getFeedbacksSummaryDataPoints = (): String[] => {
  const datapoints = [
    "Status",
    "feedback_registered",
    "feedback_completed",
    "feedback_underProgress",
  ];
  return datapoints;
};
//TODO : Translate
//TODO : make this configurable
export const getFeedbacksSummaryDataLabelsByKeyName = (
  keyName: keyof FeedbackSummaryData
): String => {
  const labels: Record<string, string> = {
    Status: "Status",
    feedback_registered: "No. of Feedbacks Registered",
    feedback_completed: "No. of Feedbacks Completed",
    feedback_underProgress: "No. of Feedbacks Under Progress",
  };

  // Check if the keyName exists in labels before accessing it
  return labels[keyName] || "";
};
export const getFeedbacksData = async (
  dateFilter: Record<string, Dayjs | null>
): Promise<Record<string, any>> => {
  const authContext = JSON.parse(localStorage.getItem("authContext") || "{}");
  const loggedInUserName = authContext.user?.loginId || ""; // Default to an empty string if not found

  // Base API URL without the unwanted parameters
  let apiUrl = "/v1/query/getSupportData";

  // Check if both fromDate and toDate are provided in the dateFilter
  if (dateFilter.fromDate && dateFilter.toDate) {
    // Format the dates to include the time part as specified
    const fromDate = dateFilter.fromDate.format("YYYY-MM-DD") + "%2000:00:00"; // Append time part
    const toDate = dateFilter.toDate.format("YYYY-MM-DD") + "%2023:59:59"; // Append time part

    // Construct the URL with query parameters
    apiUrl += `&fromDate=${fromDate}&toDate=${toDate}&loggedInUserName=${loggedInUserName}`;
} else {
    // If no dates are specified, return an error or handle it per your needs
    // return {};
    throw new Error("Both fromDate and toDate must be provided.");
}

  try {
    // Make the API call
    const response = await ChannelkartNetworkGet(apiUrl);

    // Check the response status
    if (response.status === 200) {
      console.log("response -> ", response);
      const data = response.data;
      return data; // Return the data if the fetch was successful
    } else {
      throw new Error("Network response was not ok");
      // return {};
    }
  } catch (error) {
    console.error("Error fetching feedbacks data:", error);
    throw error; // Re-throw the error for handling in calling function
    // return {};
  }
};
export const getFeedbacksDataInRequiredFormat = (
  data: Record<string, any>
): Record<string, any>[] => {
  const feedbacks = [...data.features];
  //now for each feedback convert the extended_poperty value from a string to object
  feedbacks.forEach((feedback: Record<string, any>) => {
    feedback.extended_attributes = JSON.parse(feedback.extended_attributes);
  });
  return feedbacks;
};
export const getSupportAssigneeFromID = (
  supportAssignees: Assignee[],
  id: string
): Assignee => {
  const assignee: Assignee = supportAssignees?.find(
    (assignee: Assignee) => assignee.loginId === id
  ) || { name: id || "", loginId: id || "" };
  return assignee;
};
export const formatDataForTableRows = (
  data: Record<string, any>[],
  supportAssignees: Assignee[]
): FeedbackTableRowData[] => {
  const tableRows: FeedbackTableRowData[] = data.map(
    (feedback: Record<string, any>) => {
      return {
        id: feedback.id || "",
        name: feedback.extended_attributes?.userDetails?.name || "",
        creation_time: feedback.creation_time || "",
        feedbackType: feedback.support_class || "",
        complaint: feedback.extended_attributes?.complaint || "",
        status: feedback.status || "",
        assignedTo:
          getSupportAssigneeFromID(supportAssignees, feedback.immediate_id)
            ?.name || "",
        blob_key: feedback.blob_key || "",
        remarks: feedback.remarks || "",
      };
    }
  );
  return tableRows;
};
export const getFeedbackDataFromId = (
  data: Record<string, any>[],
  id: string
): Record<string, any> => {
  console.log("getting feedback data for id -> ", id, data);
  const valueToReturn =
    data.find((feedback: Record<string, any>) => feedback.id === id) || {};
  console.log("states have the data of this id -> ", { id }, { valueToReturn });
  return valueToReturn;
};
export const getBrandsData = async (): Promise<Record<string, any>> => {
  try {
    const response = await ChannelkartNetworkGet(
      "/v1/distinctFieldData/ProductDetails/brand"
    );
    if (response.status === 200) {
      const data = response.data;
      return data; // Return the data if it's valid
    } else {
      throw new Error("Network response was not ok");
    }
  } catch (error) {
    console.error("Failed to fetch brands data:", error);
    throw error; // Return an empty object or handle the error accordingly
  }
};
export const getBrandsDataInRequiredFormat = (
  data: Record<string, any>
): string[] => {
  // Assuming data is an array of objects
  return data.map((item: Record<string, any>) => item.brand).filter(Boolean); // Filter out any undefined values
};
export const getFlavoursData = async (): Promise<Record<string, any>> => {
  try {
    const response = await ChannelkartNetworkGet(
      "/v1/distinctFieldData/ProductDetails/flavour"
    );
    if (response.status === 200) {
      const data = response.data;
      return data; // Return the data if it's valid
    } else {
      throw new Error("Network response was not ok");
      // return {};
    }
  } catch (error) {
    console.error("Failed to fetch flavours data:", error);
    throw error; // Re-throw the error for handling in calling function
    // return {}; // Return an empty object or handle the error accordingly
  }
};

export const getFlavoursDataInRequiredFormat = (
  data: Record<string, any>
): string[] => {
  // Assuming data is an array of objects
  return data.map((item: Record<string, any>) => item.flavour).filter(Boolean); // Filter out any undefined values
};

export const getFilteredFeedbacks = (
  data: FeedbacksTableDetail[],
  typeAndStatusFilter: Record<string, string>,
  searchQuery: string
): FeedbacksTableDetail[] => {
  const filteredData = data.filter((row: FeedbacksTableDetail) => {
    // Check if the feedbackType and feedbackStatus are not 'All'
    const isFilterTypeApplicable = typeAndStatusFilter?.feedbackType !== "All";
    const isFilterStatusApplicable =
      typeAndStatusFilter?.feedbackStatus !== "All";

    // Check for matching feedbackType if applicable
    const matchesType = isFilterTypeApplicable
      ? row?.feedbackType &&
        row?.feedbackType.toLowerCase() ===
          typeAndStatusFilter?.feedbackType?.toLowerCase()
      : true;

    // Check for matching feedbackStatus if applicable
    const matchesStatus = isFilterStatusApplicable
      ? row?.status &&
        row?.status?.toLowerCase() ===
          typeAndStatusFilter?.feedbackStatus?.toLowerCase()
      : true;

    // Apply the search query filter
    const matchesSearch = Object.values(row).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Return true only if all conditions match
    return matchesType && matchesStatus && matchesSearch;
  });
  return filteredData;
};

export const getFeedbackStatusList = (): string[] => {
  return FEEDBACK_STATUS_LIST;
};
export const fetchFeedbackTypeDataFromConfig = async (): Promise<string[]> => {
  try {
    const data: Record<string, any>[] = await getMetaData("clientconfig", "dse_app_options_configuration");
    const feedbackTypeList: string[] = data?.find(
      (item: Record<string, any>) => item.name === "complaintOption"
    )?.value || []; // Use default if not found
    return feedbackTypeList;
  } catch (error) {
    console.error("Error fetching Feedback Type data:", error);
    throw error;
  }
};
export const putFeedbackAssignRequestData = async (
  data: AssignSubmitRequestData
) => {
  const response = await ChannelkartNetworkPut("/support",data);
  // console.log("response for put request for assign feedback  ", response);
  return response;
};

export const putFeedbackViewRequestData = async (
  data: ViewSubmitRequestData
) => {
  const response = await ChannelkartNetworkPut("/support",data);
  // console.log("response for put request for view feedback  ", response);
  return response;
};
export const fetchManufacturingLocationsDataFromConfig = async (): Promise<
  string[]
> => {
  try {
    const data = await getMetaData(
      "clientconfig",
      "dse_app_options_configuration"
    );
    const manufacturingLocationOption = data?.find(
      (item: Record<string, any>) => item.name === "manufacturingLocationOption"
    );
    // console.log("fetchec the config data -> ", manufacturingLocationOption);
    return manufacturingLocationOption
      ? manufacturingLocationOption.value
      : []; // Adjust based on your data structure
  } catch (error) {
    console.error("Error fetching manufacturing locations data:", error);
    throw error;
  }
};
export const fetchAssigneeDataFromConfig = async (): Promise<Assignee[]> => {
  try {
    const data = await getMetaData("clientConfig", "config");
    const supportAssigneeList =
      Array.isArray(data) && data.length > 0
        ? data[0].defaultSupportAssignee
        : [];
    return supportAssigneeList;
  } catch (error) {
    console.error("Error fetching assignee data:", error);
    throw error ;
  }
};
